__webpack_require__.p = "/openmagazine/assets/";